import { isValidIsoDate, todayIso } from "../../lib/date/isoDate";
import type { FoodItemDraft } from "./types";

/** One message per invalid field. An empty object means the draft is good. */
export type DraftErrors = Partial<Record<keyof FoodItemDraft, string>>;

const MAX_NAME_LENGTH = 60;
const MAX_QUANTITY = 100_000;

export function validateDraft(draft: FoodItemDraft): DraftErrors {
  const errors: DraftErrors = {};

  const name = draft.name.trim();
  if (!name) {
    errors.name = "Name is required.";
  } else if (name.length > MAX_NAME_LENGTH) {
    errors.name = `Keep it under ${MAX_NAME_LENGTH} characters.`;
  }

  // Checked before Number(), which turns an empty string into 0 rather than NaN.
  if (!draft.quantity.trim()) {
    errors.quantity = "Quantity is required.";
  } else {
    const quantity = Number(draft.quantity);
    if (!Number.isFinite(quantity) || quantity <= 0) {
      errors.quantity = "Quantity must be a number above 0.";
    } else if (quantity > MAX_QUANTITY) {
      errors.quantity = "That quantity looks too large.";
    }
  }

  if (!isValidIsoDate(draft.purchaseDate)) {
    errors.purchaseDate = "Enter a valid date.";
    // Fixed-width ISO dates sort the same as they compare, so a plain string
    // comparison answers "is this in the future?" without any date maths.
  } else if (draft.purchaseDate > todayIso()) {
    errors.purchaseDate = "Purchase date can't be in the future.";
  }

  return errors;
}

export function hasErrors(errors: DraftErrors): boolean {
  return Object.keys(errors).length > 0;
}
